/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;
import moment from "moment";

const state = {
  mileages: [],
  mileageTransactions: [],
  allMileageTransactions: [],
  latestTransactions: [],
  monthlyAmountDialog: null,
  mileageDialog: null,
  showNewMileage: false,
  mileageData: {},
  isLoading: false,
  snackbar: { show: false, text: "", color: "deep-purple accent-4" },
  CloseOut: null
};

const getters = {
  isLoading: (state) => state.isLoading,
  getMileageData: (state) => state.mileages,
  getMileageTransactionData: (state) => state.mileageTransactions,
  getAllMileageTransactionData: (state) => state.allMileageTransactions,
  mileageDate: (state) => state.mileageData.Date,
};

const actions = {
  async getMileages({ commit }, staffID) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/mileages/${staffID}`);
      commit("SET_MILEAGES", response.data.mileages);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getLatestTransactions({ commit }, id) {
    // commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/mileageTransactions/latestTransaction/${id}`);
      commit("SET_LATEST_TRANSACTIONS", response.data.mileages);
      console.log(response.data.mileages);
      // commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async addMileage({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/mileages/`, data);
      commit("ADD_MILEAGE", response.data.mileages);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Mileage monthly amount was added",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async updateMileage({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(
        `${url}/mileages/${data.id}`,
        data.req_body
      );
      commit("UPDATE_MILEAGE", response.data.mileage);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Mileage successfully updated",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );
      commit("SET_LOADING", false);
      return response.data.mileage;
    } catch (error) {
      console.log(error);
    }
  },

  async updateMileageBalance({ commit }, {id, Amount}) {
    try {
      const response = await axios.put(
        `${url}/mileages/balance/${id}`,
        {Amount}
      );
      console.log(response);
      return response.data;
    } catch (error) {
      console.log(error);
      return error
    }
  },

  async updateStatus({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(`${url}/mileages/closeout/${data.id}`, {
        CloseOut: data.CloseOut,
      });
      commit("UPDATE_STATUS", data);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Mileage status successfully updated",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );
      commit("SET_LOADING", false);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
    }
  },

  // async deleteMileageTransaction({ commit }, id) {
  //   commit("SET_LOADING", true);
  //   try {
  //     const response = await axios.delete(`${url}/mileageTransactions/${id}`);
  //     commit("DELETE_MILEAGE_TRANSACTION", response.data);
  //     commit(
  //       "SET_SNACKBAR",
  //       {
  //         show: true,
  //         text: "Mileage successfully Deleted",
  //         color: "red accent-4",
  //       },
  //       null,
  //       { root: true }
  //     );
  //     commit("SET_LOADING", false);
  //     return response.data;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // },

  async getAllMileageTransactions({ commit }) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/mileageTransactions`);
      commit("SET_ALL_MILEAGE_TRANSACTIONS", response.data.mileages);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getMileageTransactions({ commit }, mileageID) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(
        `${url}/mileageTransactions/${mileageID}`
      );
      commit("SET_MILEAGE_TRANSACTIONS", response.data.mileages);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async addMileageTransaction({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/mileageTransactions/`, data);
      commit("ADD_MILEAGE_TRANSACTION", response.data.mileages);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Mileage successfully added",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async updateMileageTransaction({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(
        `${url}mileageTransactions/${data.id}`,
        data.req_body
      );
      commit("UPDATE_MILEAGE_TRANSACTION", response.data.mileage);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Mileage successfully updated",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async deleteMileageTransaction({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.delete(`${url}/mileageTransactions/${id}`);
      commit("DELETE_MILEAGE_TRANSACTION", response.data);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "Mileage successfully Deleted",
          color: "red accent-4",
        },
        null,
        { root: true }
      );
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  SET_ALL_MILEAGE_TRANSACTIONS(state, data) {
    state.allMileageTransactions = data;
  },

  /* for adding mileage monthly amount */

  SET_MILEAGES(state, data) {
    state.mileages = [];
    data.map((item) => {
      let dt = new Date(item.Date);
      item.Date = moment(dt).format("MM-DD-YYYY");
      state.mileages.push(item);
    });
  },
  SET_LATEST_MILEAGE_TRANSACTIONS(state, data) {
    const insertIntoArray = (arr, value) => {
      return arr.reduce((result, element, index, array) => {
        result.push(element);
        if (index < array.length - 1) {
          result.push(value);
        }
        return result;
      }, []);
    };

    state.latestTransactions = insertIntoArray(data, {
      divider: true,
      inset: true,
    });
  },

  ADD_MILEAGE(state, data) {
    state.mileages.push({
      ...data,
      Date: moment(new Date(data.Date)).format("MM-DD-YYYY"),
    });
  },
  UPDATE_MILEAGE(state, data) {
    state.mileages.splice(
      state.mileages.findIndex((mileage) => mileage._id === data._id),
      1,
      { ...data, Date: moment(new Date(data.Date)).format("MM-DD-YYYY") }
    );
  },

  DELETE_MILEAGE(state, id) {
    state.mileages.splice(
      state.mileages.findIndex((mileage) => mileage._id === id),
      1
    );
  },

  UPDATE_MILEAGE_STATUS(state, data) {
    let mileageIndex = state.mileages.findIndex((mileage) => mileage._id === data.id)
    state.mileages[mileageIndex].CloseOut = data.CloseOut
  },

  /* for adding mileage transactions */

  SET_MILEAGE_TRANSACTIONS(state, data) {
    state.mileageTransactions = [];
    data.map((item) => {
      let dt = new Date(item.Date);
      item.Date = moment(dt).format("MM-DD-YYYY");
      state.mileageTransactions.push(item);
    });
  },

  ADD_MILEAGE_TRANSACTION(state, data) {
    state.mileageTransactions.unshift({
      ...data,
      Date: moment(new Date(data.Date)).format("MM-DD-YYYY"),
    });
  },

  UPDATE_MILEAGE_TRANSACTION(state, data) {
    state.mileageTransactions.splice(
      state.mileageTransactions.findIndex(
        (mileage) => mileage._id === data._id
      ),
      1,
      { ...data, Date: moment(new Date(data.Date)).format("MM-DD-YYYY") }
    );
  },

  DELETE_MILEAGE_TRANSACTION(state, id) {
    state.mileageTransactions.splice(
      state.mileageTransactions.findIndex((mileage) => mileage._id === id),
      1
    );
  },

  SET_MONTHLY_AMOUNT_DIALOG(state, data) {
    state.monthlyAmountDialog = data;
  },

  SET_NEW_MILEAGES(state, data) {
    state.showNewMileage = data;
  },

  SET_MILEAGE_DIALOG(state, data) {
    state.mileageDialog = data;
  },

  SET_MILEAGE_DATA(state, data) {
    state.mileageData = data;
  },

  SET_MILEAGE_LOADING(state, data) {
    state.isLoading = data;
  },

  SET_MILEAGE_CLOSEOUT(state, data){
    state.CloseOut = data
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
